import { render } from "./Dinner.vue?vue&type=template&id=2e0c6bbc"
import script from "./Dinner.vue?vue&type=script&lang=js"
export * from "./Dinner.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__